import MojitoCore from 'mojito/core';
import SettingsMenuClassicImpl from './settings-menu-classic.js';

/**
 * Classic design style settings menu.
 *
 * @class SettingsMenuClassic
 * @memberof Mojito.Modules
 */
export default MojitoCore.Presentation.UIView('SettingsMenuClassic', SettingsMenuClassicImpl);
